module.exports = __webpack_public_path__ + "static/media/Logos uniservice-07 (1).48639f07.svg";